var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChina(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_33650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56719 7.3031L7.60312 10.4906H10.9547L8.24531 12.464L9.28125 15.6515L6.56719 13.6828L3.85313 15.6515L4.89375 12.464L2.17969 10.4906H5.53125L6.56719 7.3031Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.227 18.5859L13.4348 17.6109L12.2629 18.0656L12.9426 17.0109L12.1504 16.0312L13.3645 16.3547L14.0488 15.3L14.1145 16.5562L15.3332 16.8797L14.1566 17.3297L14.227 18.5859Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.802 15.7266L16.177 14.5266L15.1504 13.8L16.4066 13.7812L16.777 12.5812L17.1848 13.7719L18.441 13.7578L17.4332 14.5078L17.8363 15.6984L16.8098 14.9719L15.802 15.7266Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9246 8.80778L17.3715 9.93746L18.2715 10.814L17.0293 10.6359L16.4762 11.7609L16.2605 10.5234L15.0137 10.3453L16.1293 9.75934L15.9137 8.51715L16.8137 9.39371L17.9246 8.80778Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2592 5.38593L14.1654 6.63749L15.3326 7.11093L14.1092 7.41093L14.0201 8.66718L13.3592 7.59843L12.1357 7.89843L12.9467 6.93749L12.2811 5.87343L13.4482 6.34686L14.2592 5.38593Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_33650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/496d6e93.svg";
export { SvgChina as ReactComponent };